export default __webpack_public_path__ + "css/TopNav.module.css";